import { useMutation } from "@tanstack/react-query";
import { Text } from "@ui-kitten/components";
import BaseCard, { BaseCardListItem } from "components/BaseCard";
import BuyFlowPaymentDetailCard from "components/BuyFlowPaymentDetailCard";
import ConfirmPurchaseButton from "components/ConfirmPurchaseButton";
import Spacer from "components/Spacer";
import { setStep } from "features/slices/buyFlowSlice";
import { resetReservationFlow } from "features/slices/reservationFlowSlice";
import {
  PlanPackageDetails,
  SignupChargeDetails,
  SubscriptionDetails,
} from "features/types";
import { useAccount } from "hooks/useAccount";
import { useAppDispatch } from "hooks/useAppDispatch";
import { changeSubscriptionsFetcher } from "queries/account.queries";
import React from "react";
import { View } from "react-native";
import PaymentMethodCard from "screens/Account/components/PaymentMethodCard";
import { toManageMemberSubscription } from "utils/navigationUtils";
import toast from "utils/toast";
import { PlanChanges } from "../types";

interface UpgradePlanStepTwoProps {
  planChangeCharge: SignupChargeDetails | undefined;
  selectedUpgradePlan: PlanPackageDetails;
  selectedSubscription: SubscriptionDetails;
  planChanges: PlanChanges;
}

const UpgradePlanStepTwo: React.FC<UpgradePlanStepTwoProps> = ({
  planChangeCharge,
  selectedSubscription,
  selectedUpgradePlan,
  planChanges,
}) => {
  const { account, fetchAccount } = useAccount();

  if (!account) return null;
  const { subscriptions } = account;
  const dispatch = useAppDispatch();
  const { mutateAsync: changeSubscriptions, isLoading: loading } = useMutation(
    changeSubscriptionsFetcher
  );
  const sameSubscriptionsInAccount = subscriptions.filter(
    (sub) =>
      !sub.expired && sub.planPackage.id === selectedSubscription.planPackage.id
  );

  const handleBtnPress = async () => {
    await changeSubscriptions({
      accountId: account.id,
      changes: planChanges,
      source: "FANRALLY_APP",
    });
    fetchAccount();
    dispatch(resetReservationFlow());
    dispatch(setStep(1));
    toManageMemberSubscription(String(selectedSubscription?.member.id));
    toast.success("Congratulations, your plan has been successfully changed.");
  };

  return (
    <View>
      <BaseCard title="Switching Plans">
        <View style={{ marginTop: 25 }}>
          <Text>Current plan:</Text>
          <Text category="h6" style={{ marginVertical: 5 }}>
            {selectedSubscription.planPackage.name}
          </Text>
          <Text>Switching to:</Text>
          <Text category="h6" style={{ marginVertical: 5 }}>
            {selectedUpgradePlan.name}
          </Text>
        </View>
        <BaseCardListItem
          showArrow={false}
          title={`Total Quantity: ${sameSubscriptionsInAccount.length}`}
        />
      </BaseCard>

      <Spacer />
      <BuyFlowPaymentDetailCard
        planPackage={selectedUpgradePlan}
        signupCharge={planChangeCharge}
      />
      <Spacer />
      <PaymentMethodCard />
      <Spacer />
      <ConfirmPurchaseButton
        charge={parseFloat(planChangeCharge?.signupCharge || "0")}
        buttonText="Confirm Upgrade"
        onPress={handleBtnPress}
        loading={loading}
        disabled={loading || !planChangeCharge}
      />
    </View>
  );
};

export default UpgradePlanStepTwo;
